"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var ui_vector_graphic_1 = require("@hopin-team/ui-vector-graphic");
var react_1 = tslib_1.__importStar(require("react"));
var icons_1 = require("./icons");
var root_1 = require("./styled/root");
var Icon = function (_a) {
    var className = _a.className, __UIScope = _a.__UIScope, testID = _a["data-testid"], _b = _a.scale, scale = _b === void 0 ? 2 : _b, _c = _a.color, color = _c === void 0 ? 'grey-dark' : _c, name = _a.name, id = _a.id, 
    // 👇 Removing the space props, so they don’t get passed to VectorGraphic
    // through `...rest` and cause double spacing.
    _m = _a.m, _mb = _a.mb, _ml = _a.ml, _mr = _a.mr, _mt = _a.mt, _mx = _a.mx, _my = _a.my, _p = _a.p, _pb = _a.pb, _pl = _a.pl, _pr = _a.pr, _pt = _a.pt, _px = _a.px, _py = _a.py, isFlexible = _a.isFlexible, isParentColor = _a.isParentColor, _d = _a.colorTransition, colorTransition = _d === void 0 ? true : _d, rest = tslib_1.__rest(_a, ["className", "__UIScope", 'data-testid', "scale", "color", "name", "id", "m", "mb", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py", "isFlexible", "isParentColor", "colorTransition"]);
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'Icon',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var Icon = (0, react_1.useMemo)(function () { return icons_1.icons[name]; }, [name]);
    if (!Icon) {
        return react_1.default.createElement("div", null);
    }
    return (react_1.default.createElement(root_1.Root, { className: rootClasses, "data-testid": testID, scale: scale, color: color, isFlexible: isFlexible, isParentColor: isParentColor, colorTransition: colorTransition },
        react_1.default.createElement(ui_vector_graphic_1.VectorGraphic, tslib_1.__assign({ viewBox: "0 0 24 24" }, rest),
            react_1.default.createElement(Icon, { id: id }))));
};
var IconWithSpace = (0, ui_helper_with_space_1.withSpace)(Icon);
exports.Icon = IconWithSpace;
//# sourceMappingURL=icon.js.map